import { render, staticRenderFns } from "./Ring.vue?vue&type=template&id=4b641306&scoped=true"
import script from "./Ring.vue?vue&type=script&lang=js"
export * from "./Ring.vue?vue&type=script&lang=js"
import style0 from "./Ring.vue?vue&type=style&index=0&id=4b641306&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b641306",
  null
  
)

export default component.exports